import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/contact/sync/user.contact.sync.mutation.gql"
import type {
  UserContactSyncMutation,
  UserContactSyncMutationVariables,
} from "@/v2-backoffice-client/user/contact/sync/__types__/user.contact.sync.mutation"

type Options = MutationHookOptions<
  UserContactSyncMutation,
  UserContactSyncMutationVariables
>

// Returns the full updated user, so the normalized cache refreshes the
// Contact snapshot + ContactSyncStatus in every table/panel at once.
export function useUserContactSyncMutation(options?: Options) {
  return useMutation<UserContactSyncMutation, UserContactSyncMutationVariables>(
    mutation,
    options,
  )
}
